import { Component, OnInit, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';
import { BannerPrincipalCotizarPorWhatsapp } from './cotizar-por-whatsapp/banner-principal-cotizar-por-whatsapp';
import { PorqueCotizarPorWhatsapp } from './cotizar-por-whatsapp/porque-cotizar-por-whatsapp';
import { ComoCotizarPorWhatsapp } from './cotizar-por-whatsapp/como-cotizar-por-whatsapp';
import { QuePuedesCotizar } from './cotizar-por-whatsapp/que-puedes-cotizar';
import { EscribenosAhora } from './cotizar-por-whatsapp/escribenos-ahora';
import { MarginWrapper } from '../../layouts/margin-wrapper';

@Component({
  selector: 'allas-cotiza-whatsapp',
  imports: [
    MainLayout,
    BannerPrincipalCotizarPorWhatsapp,
    PorqueCotizarPorWhatsapp,
    ComoCotizarPorWhatsapp,
    QuePuedesCotizar,
    EscribenosAhora,
    MarginWrapper,
  ],
  template: `
    <allas-main-layout>
      <allas-margin-wrapper styleClass="bg-white">
        <!-- Titulo Programa de Recompensas -->
        <h1 class="text-lg xl:text-4xl my-2 xl:my-4 font-medium fs-condensed">
          COTIZAR POR WHATSAPP
        </h1>
        <allas-banner-principal-cotizar-por-whatsapp></allas-banner-principal-cotizar-por-whatsapp>
        <allas-porque-cotizar-por-whatsapp></allas-porque-cotizar-por-whatsapp>
        <allas-como-cotizar-por-whatsapp></allas-como-cotizar-por-whatsapp>
        <allas-que-puedes-cotizar></allas-que-puedes-cotizar>
        <allas-escribenos-ahora></allas-escribenos-ahora>
      </allas-margin-wrapper>
    </allas-main-layout>
  `,
})
export class CotizaPorWhatsapp implements OnInit {
  private title = inject(Title);
  private meta = inject(Meta);

  ngOnInit() {
    this.setMetaTags();
  }

  private setMetaTags() {
    const pageTitle = 'Cotizar Repuestos por WhatsApp | Allas Repuestos';
    const description =
      'Cotiza repuestos automotrices por WhatsApp al instante. Respuesta rápida, sin compromiso y atención personalizada. Envío a domicilio en Honduras.';
    const keywords =
      'cotizar repuestos, WhatsApp, repuestos automotrices, Allas Repuestos, envío a domicilio, Honduras, baterías, filtros, frenos, suspensión';
    const imageUrl = 'https://www.allasrepuestos.com/logos/isotipo.webp';

    // --- Título de la página ---
    this.title.setTitle(pageTitle);

    // --- Meta Descripción ---
    this.meta.updateTag({
      name: 'description',
      content: description,
    });

    // --- Palabras Clave ---
    this.meta.updateTag({
      name: 'keywords',
      content: keywords,
    });

    // --- Open Graph Tags ---
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    // --- Twitter Tags ---
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

    // --- Icono del sitio (favicon / logo principal) ---
    this.meta.updateTag({
      name: 'icon',
      content: imageUrl,
    });
  }
}
